import {
  axiosInstance as Repository,
  RESULT_CD,
  RepositoryError,
} from "../repository";

const RESOURCE = "/organizations";

/* カスタム例外 */
class BillingsRepositoryError extends RepositoryError {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    this.errorCd = BillingsRepositoryError.getErrorCd();
  }

  static getErrorCd() {
    return "08000";
  }
}

const BilingsRepository = {

  async get(organizationId, billingId) {
    const response = await Repository.get(`${RESOURCE}/${organizationId}/billings/${billingId}`);

    // 処理結果の確認
    if (response.data.result_cd !== RESULT_CD.SUCCESS) {
      throw new BillingsRepositoryError();
    }
    return response.data.item;
  },

  async getPaymentHistory(organizationId) {
    const response = await Repository.get(`${RESOURCE}/${organizationId}/billings/get-payment-history`);

    // 処理結果の確認
    if (response.data.result_cd !== RESULT_CD.SUCCESS) {
      throw new BillingsRepositoryError();
    }
    return response.data.items;
  },

  async getBillingItems(organizationId, billingId) {
    const response = await Repository.get(`${RESOURCE}/${organizationId}/billings/${billingId}/get-billing-items`);

    // 処理結果の確認
    if (response.data.result_cd !== RESULT_CD.SUCCESS) {
      throw new BillingsRepositoryError();
    }
    return response.data.items;
  },
};

export {
  BilingsRepository,
  BillingsRepositoryError,
};
